// extracted by mini-css-extract-plugin
module.exports = {"w1fyjtsg":"w1fyjtsg"};